<template>
	<div class="form-mdfpwd">

		<el-form ref="form" :model="form" :rules="rules" label-width="">
			<div class="pwdhead">
				<span class="pwdtitle">设定</span>
				<div class="closediv" @click="close"><span class="close"></span></div>
			</div>
			<el-form-item :label="form.ThisActive.name+'  : '" prop="ThisActive.value">
				<el-input placeholder="请填写属性值" 
					v-model="form.ThisActive.value" 
					@input="onkeyupFun"
					@keyup.enter.native="submitForm('form')" 
					clearable> </el-input>
			</el-form-item>
			<button type="button" @click="submitForm('form')" class="ely-button"><span>确定</span></button>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'mdfpwd',
		props: {
			companyId: {
				type: Number,
				request: true
			}
		},
		data() {
			var validatePass = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请填写属性值'));
				} else {
					callback();
				}
			};

			return {
				form: {
					id: '',
					value: '',
					ThisActive: {},
				},
				rules: {
					ThisActive:{
						value: [{
							type: 'number',
							required: true,
							validator: validatePass,
							trigger: 'change'
						}],
					}
				},
				type: '',
				min: null,
				max: null,
				step: null,
			}
		},
		methods: {
			binding(item,type) {
				this.type = type;
				this.form.ThisActive = JSON.parse(JSON.stringify(item));
				this.min = Number(this.form.ThisActive.specs.min)
				this.max = Number(this.form.ThisActive.specs.max)
				this.step = Number(this.form.ThisActive.specs.step)
			},
			onkeyupFun(value){
				this.form.ThisActive.value = value.replace(/[^\d.]/g,'');
				if(value > this.max){
					this.form.ThisActive.value = this.max;
				}else if(value < this.min){
					this.form.ThisActive.value = this.min;
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate(valid => {
					if(valid) {
						//如果通过验证 to do...
						//console.log(this.form.name)
						//this.common.permission(this);
						var self = this;
						let obj = {
							deviceCode: this.form.ThisActive.DeviceCode,	
							property: this.form.ThisActive.id,
							value: this.form.ThisActive.value,
							companyId: this.companyId
						};
						this.post('/Device/setPropertyValue', obj).then((res) => {
							if(res.success == true) {
								this.$message({
							        showClose: true,
							        message: '修改成功',
					        		customClass: 'backMessage',
							        type: 'success'
							   	});
							   	//更新看板属性值
							   	this.$parent.AttrDataUpdata(this.form.ThisActive.id,this.form.ThisActive.value,this.type);
								//隐藏
								this.$parent.MdfClassify();
								//清楚校验结果
								this.$refs.form.resetFields();
							}
						})
					}
				})
			},
			close() {
				this.$parent.MdfClassify();
			}
		}
	}
</script>

<style scoped>
	.backMessage {
		background-color: #363738 !important;
		border: 0px !important;
	}
	
	.backMessage .el-message__content {
		color: #DADADA !important;
	}
	
	.backMessage .el-message__icon.el-icon-success {
		color: #DADADA !important;
	}
	
	.form-mdfpwd {
	    width: 100vw;
	    height: 100vh;
	    display: none;
	    background: rgba(0, 0, 0, .4);
	    position: absolute;
	    top: -90px;
	    bottom: 0;
	    left: -1px;
	    right: 0;
	    z-index: 200;
	    margin: auto;
	    opacity: 0;
	    -webkit-transition: .2s;
	    transition: .2s;
	}
	
	.el-form {
		display: block;
		width: 495px;
		height: 193px;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: -50px;
	    transition: .2s;
		background-color: #fff;
		border-radius: 1px;
	}
	
	.pwdhead {
		width: 100%;
		height: 53px;
		border-bottom: 1px solid #efefef;
	}
	
	.pwdhead .pwdtitle {
		float: left;
		color: #2F3A4E;
		font-size: 17px;
		margin-left: 30px;
		margin-top: 14px;
		cursor: context-menu;
	}
	
	.pwdhead .closediv {
		float: right;
		position: relative;
		margin-right: 25px;
		margin-top: 12px;
		width: 2rem;
		height: 2rem;
		cursor: pointer;
	}
	
	.pwdhead .close {
		float: right;
		position: relative;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		display: inline-block;
		top: 5px;
		right: 15px;
	}
	
	.pwdhead .close:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(270deg);
		-moz-transform: rotate(270deg);
		-o-transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		transform: rotate(270deg);
	}
	
	.el-form-item {
		margin: 0;
		padding-left: 13px;
		padding-top: 22px;
	}
	
	.el-form-item>>>.el-form-item__label {
		float: left;
		width: 135px;
		color: #2c3e50;
	}
	
	.el-form-item>>>.el-form-item__content {
		float: left;
		width: 289px;
	}
	
	.el-form-item>>>.el-input__inner {
		padding: 0 !important;
		margin: 0 !important;
		color: #2F3030 !important;
		background: #fff !important;
		text-indent: 20px !important;
		border: 1px solid rgba(222, 222, 222, 1) !important;
	}
	
	.el-form>>>.ely-button {
		background-color: #5087E4;
		color: #fff;
		width: 86px;
		letter-spacing: 1px;
		margin-top: 18px;
		font-size: 13px;
		cursor: pointer;
		border: 0;
		border-radius: 5px;
		height: 34px;
		line-height: 33px;
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		margin-top: 23px;
	}
	
	.el-form>>>.el-select {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/MapEditor/canvas/Draggable/draggable/MdfClassifyCan.vue